import {
	APPLY_FILTER_FAIL,
	APPLY_FILTER_SUCCESS,
	CLEAR_FILTER_SUCCESS,
	CLEAR_FILTER_FAIL,
	REMOVE_FILTER_SUCCESS,
} from './types';

const initialState = {
	leadsFilter: {},
	removeFilterFromLeads: false,
	loading: true,
};

export default function (state = initialState, action) {
	const { type, payload } = action;

	switch (type) {
		case APPLY_FILTER_SUCCESS:
		case APPLY_FILTER_FAIL:
		case CLEAR_FILTER_SUCCESS:
		case CLEAR_FILTER_FAIL:
			return {
				...state,
				leadsFilter: payload['leadsFilter']
					? payload['leadsFilter']
					: {},
				loading: false,
			};
		case REMOVE_FILTER_SUCCESS:
			return {
				...state,
				leadsFilter: payload['leadsFilter'],
				loading: false,
			};
		default:
			return state;
	}
}
